import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import './Rooms.css';

export default function Rooms() {
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true); // ✅ loading state
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/rooms')
      .then((res) => setRooms(res.data))
      .catch((err) => console.error(err))
      .finally(() => setLoading(false)); // ✅ stop loading
  }, []);

  const handleNext = () => {
    navigate('/booking/step1');
  };

  if (loading) {
    return (
      <div className="loader-container">
        <div className="spinner"></div>
        <p>Cargando habitaciones...</p>
      </div>
    );
  }

  return (
    <div className="rooms-container">
      <h2>Habitaciones Disponibles</h2>
      {rooms.map((room) => (
        <div key={room._id} className="room-card">
          <h3>{room.name}</h3>
          <p>{room.description}</p>
          
          <p><strong>Precio para 2 personas :</strong> ${room.price*(1-(2)*0.10)} / noche</p>
          <p><strong>Capacidad:</strong> {room.capacity} personas</p>

          <div className="image-gallery">
            {room.images.map((img, idx) => (
              <img key={idx} src={img} alt={`Imagen ${idx + 1}`} />
            ))}
          </div>
          <button onClick={handleNext}>Reservar!</button>
        </div>
      ))}
    </div>
  );
}
